import { Breakpoints, Container, ContainerPadding, LayoutRowGap } from '@volkswagen-onehub/components-core';
import React from 'react';
import { isLayerForm } from '../../helpers/form-helpers';
import { LayoutExtended } from './core/layout-extended';

interface SectionProps {
	children: React.ReactNode;
	paddingTop?: ContainerPadding;
	paddingBottom?: ContainerPadding;
	disableScrollFocus?: boolean;
}

export function Section(props: SectionProps) {
	const { children, paddingTop, paddingBottom, disableScrollFocus = false } = props;

	const handleSectionFocus = (e: React.FocusEvent) => {
		if (disableScrollFocus) return;

		if (window.innerWidth < 960) return;

		if (!e.currentTarget.contains(e.relatedTarget as Node)) {
			const element = e.currentTarget as HTMLElement;
			setTimeout(() => {
				element.scrollIntoView({ behavior: 'smooth', block: 'center' });
			}, 100);
		}
	};

	return (
		<div className="section" onFocus={handleSectionFocus}>
			<Container
				stretchContent
				padding={{ top: paddingTop || undefined, bottom: paddingBottom || undefined }}
				// @ts-expect-error
				style={{ overflow: 'visible' }}
			>
				<LayoutExtended
					allowOverflowingContent
					appearance={
						isLayerForm()
							? {
									[Breakpoints.default]: [
										{ name: '.', columns: 1 },
										{ name: 'a', columns: 22 },
										{ name: '.', columns: 1 },
									],
								}
							: {
									[Breakpoints.default]: [{ name: 'a', columns: 24 }],
								}
					}
					rowGap={LayoutRowGap.static300}
				>
					{children}
				</LayoutExtended>
			</Container>
		</div>
	);
}
